import { getOr } from 'lodash/fp';
import AnalyticsConstants from '../../../analytics/constants';
import { createAndSendPageLoadEvent } from '../../../analytics/commonAnalytics';

const pageName = getOr(AnalyticsConstants.PageNames.MyEstimates, 'digitalData.page.pageInfo.pageName', window);
const pageType = getOr(AnalyticsConstants.PageTypes.Estimates, 'digitalData.page.pageInfo.pageType', window);

export default () => {
  createAndSendPageLoadEvent(
    window.globalConfig.siteId,
    pageName,
    pageType,
  );
};
